export const fleetdata = [
    {
        GenerationStats: {
            name: "Month to Date Generation Stats",
            headerNames: {
                headeName1: "Total (MWh)",
                headeName2: "Revenue (Million)",
                headeName3: "Performance Ratio",
                headeName4: "Avg Daylight Duration",
            },
            headerValues: {
                headerValue1: 70236,
                headerValue2: "$3.01",
                headerValue3: '79%',
                headerValue4: "10 hr",
            },
            data: [3, 3.02, 3.05, 3.07, 3, 3.03, 3.01]
        },
        Availability: {
            formatter: "MWh",
            seriesname: 'Daily Power Generation',
            name: "Daily Power Generation",
            subName: " (7023.6 MWh)",
            percentage: "1%",
            arrow: "arrow_upward",
            data: [7010, 7023, 6912, 6834, 7000]
        },
        HeatRate: {
            formatter: "KWh/m2",
            seriesname: 'Daily Avg. Irradiation',
            name: "Daily Avg. Irradiation",
            subName: " (5.70 KWh/m2)",
            percentage: "1%",
            arrow: "arrow_upward",
            data: [4.4, 5.2, 5.3, 4.4, 4.5, 5.7]
        },
        DMWaterConsumption: {
            formatter: "%",
            seriesname: 'Daily Avg. PR',
            name: "Daily Avg. PR",
            subName: " (80%)",
            percentage: "0.2%",
            arrow: "arrow_downward",
            data: [79, 80, 81, 80, 80]
        },
        AuxPowerConsumption: {
            formatter: "",
            seriesname: 'No. ',
            name: "Underperforming Inverters",
            subName: " (4)",
            percentage: "10%",
            arrow: "arrow_downward",
            data: [9, 11, 7, 9, 8]
        },
        tableData: {
            name: "Plant Overview",
            data: [
                { PlantName: "Walton", Generation: 20,/*CapacityFactor:20,*/DaylightDuration: "11.20 hr", InvertersOperating: "20/20", CurrentYearAvailability: 99, InvertersatRisk: "2/20", PR: 76 },
                { PlantName: "Bear Creek", Generation: 22,/*CapacityFactor:25,*/DaylightDuration: "10.70 hr", InvertersOperating: "9/10", CurrentYearAvailability: 99, InvertersatRisk: "1/10", PR: 80 },
                { PlantName: "Fern Solar", Generation: 23,/*CapacityFactor:45,*/DaylightDuration: "10.50 hr", InvertersOperating: "17/17", CurrentYearAvailability: 98, InvertersatRisk: "1/17", PR: 81 },
            ]
        },
        SystemsRisk: {
            name: "Fleet Health",
            data: [{ name: 'High', value: 4 }, { name: 'Medium', value: 3 }, { name: 'Low', value: 40 }],
        },
        stachbar: {
            name: "Fleet Heatlh (Weekly)",
            value: [
                { name: "Walton", data: [2, 3, 3, 2, 2, 3, 3, 1, 2, 2, 2] },
                { name: "Bear Creek", data: [1, 2, 2, 3, 2, 2, 2, 2, 2, 2, 1] },
                { name: "Fern Solar", data: [0, 1, 1, 2, 1, 0, 1, 1, 1, 1, 1] },
            ]
        },
        SystemsHighRisk: {
            data: ["Fern Solar - Inv 4", "Bear Creek - Inv 9", "Fern Solar - Inv 6", "Bear Creek - Inv 5", "Fern Solar - Inv 11", "Bear Creek - Inv 3", "Walton - Inv 14", "Walton - Inv 2"],
            value: [5, 8, 10, 11, 13, 14, 16, 17]
        }
    },

{
    GenerationStats: {
        name: "Daily Generation Stats",
        headerNames: {
            headeName1: "Total (MWh)",
            headeName2: "Revenue (Million)",
            headeName3: "Capacity Factor",
            headeName4: "Average Availability",
        },
        headerValues: {
            headerValue1: 10124,
            headerValue2: "$60.50",
            headerValue3: '34%',
            headerValue4: "96%",
        },
        data: [65, 61, 75, 71, 70, 60, 65]
    },
    Availability: {
        formatter: "MWh",
        seriesname: 'Power Generation',
        name: "Aggregated Power Generation",
        subName: " (70236 MWh)",
        percentage: "1%",
        arrow: "arrow_upward",
        data: [70100, 70234, 69124, 68345, 70000]
    },
    HeatRate: {
        formatter: "%",
        seriesname: 'Availability',
        name: "Average Availability ",
        subName: " (96%)",
        percentage: "1%",
        arrow: "arrow_upward",
        data: [91, 93, 94, 95, 95]
    },
    DMWaterConsumption: {
        formatter: "m/s",
        seriesname: 'Wind Speed',
        name: "Average Wind Speed",
        subName: " (6.75 m/s)",
        percentage: "0.2%",
        arrow: "arrow_downward",
        data: [6, 5.8, 6.4, 6.8, 6.8 ]
    },
    AuxPowerConsumption: {
        formatter: "",
        seriesname: 'No. ',
        name: "Turbines at High Risk",
        subName: " (8)",
        percentage: "10%",
        arrow: "arrow_downward",
        data: [9, 11, 7.5, 9, 8]
    },
    tableData: {
        name: "Plant Overview",
        data: [
            {PlantName:"Fowler",Generation:20,CapacityFactor:20,WindSpeed:"6.5 m/s",TurbinesRunning: "50/50",CurrentYearAvailability :84,SystemsatRisk:"3/50"},
            {PlantName:"Desert Creek",Generation:15,CapacityFactor:25,WindSpeed:"6.7 m/s",TurbinesRunning: "25/30",CurrentYearAvailability :93,SystemsatRisk:"4/30"},
            {PlantName:"Cedar Creek",Generation:10,CapacityFactor:45,WindSpeed:"7 m/s",TurbinesRunning: "24/25",CurrentYearAvailability :85,SystemsatRisk:"1/25"},
        ]
    },
    SystemsRisk: {
        name: "Systems at High Risk",
        data: [{ name: 'High', value: 8 }, { name: 'Medium', value: 20 }, { name: 'Low', value: 77 }],
    },
    stachbar: {
        name: "Cumulative Systems at Risk (Weekly)",
        value: [
            { name: "Fowler", data: [ 2, 3, 3, 4, 4, 3, 3, 3, 3, 4, 4] },
            { name: "Desert Creek", data: [4,3,3,4,2,2,2,3,4,4,2] },
            { name: "Cedar Creek", data: [2,1,1,2,3,2,1,1,2,2,2] },
        ]
    },
    SystemsHighRisk: {
        data: ["Desert Creek - WT7", "Desert Creek - WT5", "Fowler - WT42", "Fowler - WT28", "Cedar Creek - WT31", "Fowler - WT41", "Cedar Creek - WT6", "Fowler - WT31", "Desert Creek - WT2", "Fowler - WT21"],
        value: [2, 3, 5, 8, 10, 11, 13, 14, 16, 17]
    }
},
{},
{},
{
    GenerationStats: {
        name: "Daily Generation Stats",
        headerNames: {
            headeName1: "Total (MWh)",
            headeName2: "Revenue (Million)",
            headeName3: "Load Factor",
            headeName4: "Fuel Costs (Million)",
        },
        headerValues: {
            headerValue1: 60250,
            headerValue2: "$60.50",
            headerValue3: '85%',
            headerValue4: "$35.50",
        },
        data: [60, 65, 70, 67, 72, 65, 65]
    },
    Availability: {
        formatter: "%",
        seriesname: 'Availability',
        name: "Average Availability",
        subName: " (86%)",
        percentage: "1%",
        arrow: "arrow_upward",
        data: [81, 83, 84, 85, 85]
    },
    HeatRate: {
        formatter: "KCal/KWh",
        seriesname: 'Heat Rate',
        name: "Average Heat Rate",
        subName: " (2050 KCal/KWh)",
        percentage: "0.2%",
        arrow: "arrow_downward",
        data: [2050, 2030, 2040, 2050, 2055]
    },
    DMWaterConsumption: {
        formatter: "KGallons",
        seriesname: 'DM Water Consumption',
        name: "Average DM Water",
        subName: " (601 KGallons)",
        percentage: "0.2%",
        arrow: "arrow_upward",
        data: [601, 602, 603, 601, 601]
    },
    AuxPowerConsumption: {
        formatter: "",
        seriesname: 'Aux Power Consumption',
        name: "Average Aux Power",
        subName: " (7% of Generation)",
        percentage: "0.5%",
        arrow: "arrow_downward",
        data: [9, 11, 7.5, 7, 7]
    },
    tableData: {
        name: "Plant Overview",
        data: [
            {PlantName:"Fayette",Generation:3800,PlantLoadFactor:80,UnitsRunning:"4/5",CurrentYearAvailability :84,SystemsatRisk:"6/90"},
            {PlantName:"Tulsa",Generation:1300,PlantLoadFactor:98,UnitsRunning:"3/3",CurrentYearAvailability :93,SystemsatRisk:"4/45"},
            {PlantName:"Vogle",Generation:900,PlantLoadFactor:75,UnitsRunning:"2/3",CurrentYearAvailability :85,SystemsatRisk:"3/45"},
            {PlantName:"Ferguson",Generation:700,PlantLoadFactor:75,UnitsRunning:"3/4",CurrentYearAvailability :90,SystemsatRisk:"2/60"},
            {PlantName:"Winchester",Generation:550,PlantLoadFactor:101,UnitsRunning:"2/2",CurrentYearAvailability :95,SystemsatRisk:"0/30"},
        ]
    },
    SystemsRisk: {
        name: "Systems at High Risk",
        data: [{ name: 'High', value: 15 }, { name: 'Medium', value: 55 }, { name: 'Low', value: 189 }],
    },
    stachbar: {
        name: "Cumulative Systems at Risk (Weekly)",
        value: [
            { name: "Fayette", data: [1, 2, 3, 3, 4, 4, 3, 4, 4, 5, 6] },
            { name: "Tulsa", data: [2, 3, 3, 4, 4, 4, 3, 3, 3, 3, 4, 4] },
            { name: "Vogle", data: [4, 3, 3, 4, 2, 2, 2, 3, 4, 4, 3] },
            { name: "Ferguson", data: [2, 1, 1, 2, 3, 2, 1, 1, 2, 2, 2] },
            { name: "Winchester", data: [1, 1, 0, 1, 1, 0, 1, 1, 0, 0] },
        ]
    },
    SystemsHighRisk: {
        data: ["Fayette - Condenser", "Vogle - ID Fan", "Tulsa - Coal Mill", "Vogle - FD Fan", "Tulsa - Boiler Feed Pump B", "Fayette - Boiler Feed Pump A", "Fayette - Boiler", "Vogle - Turbine", "Tulsa - Turbine", "Fayette - Generator"],
        value: [2, 3, 5, 8, 10, 11, 13, 14, 16, 17]
    }
}
]

export const plantData = [
    {
        GenerationStats: {
            name: "Month to date Generation Stats",
            headerNames: {
                headeName1: "Total (MWh)",
                headeName2: "Revenue",
                headeName3: "Performance Ratio",
                headeName4: "Avg Daylight Duration",
            },
            headerValues: {
                headerValue1: 760,
                headerValue2: "$32,571.43",
                headerValue3: '75%',
                headerValue4: "11 hr",
            },
            siteLevel: true,
            data: [31571.43, 30571.43, 29571.43, 31771.43, 30571.43, 32571.43]
        },
        Availability: {
            formatter: "MWh",
            seriesname: 'Daily Agg. Power Generation',
            name: "Daily Agg. Power Generation",
            subName: " (76 MWh)",
            percentage: "1%",
            arrow: "arrow_upward",
            data: [70, 70, 69, 65, 75]
        },
        HeatRate: {
            formatter: "KWh/m2",
            seriesname: 'Daily Avg. Irradiation',
            name: "Daily Avg. Irradiation",
            subName: " (5.61 KWh/m2)",
            percentage: "1%",
            arrow: "arrow_upward",
            data: [5, 5.2, 5.3, 4.4, 4.5, 5.6]
        },
        DMWaterConsumption: {
            formatter: "%",
            seriesname: 'Daily Avg. PR',
            name: "Daily Avg. PR",
            subName: " (79%)",
            percentage: "0.2%",
            arrow: "arrow_downward",
            data: [79, 80, 81, 80, 80]
        },
        AuxPowerConsumption: {
            formatter: "",
            seriesname: 'No. ',
            name: "Underperforming Inverters",
            subName: " (4)",
            percentage: "10%",
            arrow: "arrow_downward",
            data: [9, 11, 7, 9, 8]
        },
        tableData: {
            name: "System Overview",
            data: [
                {
                    SystemName: "Inverter 1", 'Generation(MW)': 20, DaylightDuration: "11.20", PR: 76, CurrentYearAvailability: 99, ActiveAlerts: 'Yes'

                },
                {
                    SystemName: "Inverter 2", 'Generation(MW)': 22, DaylightDuration: "10.70", PR: 80, CurrentYearAvailability: 99, ActiveAlerts: 'No'
                },
                {
                    SystemName: "Inverter 3", 'Generation(MW)': 23, DaylightDuration: "10.50", PR: 81, CurrentYearAvailability: 98, ActiveAlerts: 'No'
                },
                {
                    SystemName: "Inverter 4", 'Generation(MW)': 21, DaylightDuration: "10.50", PR: 78, CurrentYearAvailability: 98, ActiveAlerts: 'No'
                },
                {
                    SystemName: "Inverter 5", 'Generation(MW)': 20.5, DaylightDuration: "10.50", PR: 77, CurrentYearAvailability: 99, ActiveAlerts: 'Yes'
                },
            ]
        },
        SystemsRisk: {
            name: "Inverter Health",
            data: [{ name: 'High', value: 4 }, { name: 'Medium', value: 3 }, { name: 'Low', value: 43 }],
        },
        stachbar: {
            name: "Inverter Health (Weekly)",
            value: [
                {
                    name: "Low", data: [2, 3, 3, 2, 2, 3, 3, 1, 2, 2, 2]
                },
                {
                    name: "Medium", data: [1, 2, 2, 3, 2, 2, 2, 2, 2, 2, 1]
                },
                {
                    name: "High", data: [0, 1, 1, 2, 1, 0, 1, 1, 1, 1, 1]
                },
            ]
        },
        SystemsHighRisk: {
            data: ['ICR 6 Inverter 3', 'ICR 4 Inverter 1', 'ICR 6 Inverter 2', 'ICR 2 Inverter 1', 'ICR 1 Inverter 3', 'ICR 2 Inverter 3', 'ICR8 Inverter 1', 'ICR3 Inverter 1'],
            value: [1, 1, 1, 1, 1, 1, 3, 5]
        }
    },

{
    GenerationStats: {
        name: "Daily Generation Stats",
        headerNames: {
            headeName1: "Total (MWh)",
            headeName2: "Revenue (Million)",
            headeName3: "Capacity Factor",
            headeName4: "Average Availability",
        },
        headerValues: {
            headerValue1: 5124,
            headerValue2: "$5.04 ",
            headerValue3: '34%',
            headerValue4: "98%",
        },
        data: [7, 8, 7.5, 9, 8.5, 10.5]
    },
    Availability: {
        formatter: "MWh",
        seriesname: 'Power Generation',
        name: "Aggregated Power Generation",
        subName: " (35868 MWh)",
        percentage: "1%",
        arrow: "arrow_upward",
        data: [35100, 35234, 35124, 35345, 35000]
    },
    HeatRate: {
        formatter: "%",
        seriesname: 'Availability',
        name: "Average Availability ",
        subName: " (98%)",
        percentage: "3%",
        arrow: "arrow_upward",
        data: [91, 93, 94, 95, 95]
    },
    DMWaterConsumption: {
        formatter: "m/s",
        seriesname: 'Wind Speed',
        name: "Average Wind Speed",
        subName: " (6.75 m/s)",
        percentage: "0.2%",
        arrow: "arrow_downward",
        data: [6, 5.8, 6.4, 6.8, 6.8 ]
    },
    AuxPowerConsumption: {
        formatter: "",
        seriesname: 'No. ',
        name: "Turbines at High Risk",
        subName: " (3)",
        percentage: "20%",
        arrow: "arrow_downward",
        data: [3, 4, 3, 4, 4]
    },
    tableData: {
        name: "Asset Overview",
        data: [
            {AssetName:"WT-01",GenerationKW:180,CapacityFactor:10,WindSpeed:"6 m/s",HubSpeed: 9,CurrentYearAvailability :96},
            {AssetName:"WT-02",GenerationKW:300,CapacityFactor:19,WindSpeed:"8 m/s",HubSpeed: 11,CurrentYearAvailability :97},
            {AssetName:"WT-03",GenerationKW:190,CapacityFactor:11,WindSpeed:"6.2 m/s",HubSpeed: 9.5,CurrentYearAvailability :90},
            {AssetName:"WT-04",GenerationKW:220,CapacityFactor:15,WindSpeed:"7 m/s",HubSpeed: 10,CurrentYearAvailability :95},
            {AssetName:"WT-05",GenerationKW:230,CapacityFactor:15,WindSpeed:"7 m/s",HubSpeed: 10,CurrentYearAvailability :97},
        ]
    },
    SystemsRisk: {
        name: "Turbines at Risk",
        data: [{ name: 'High', value: 3 }, { name: 'Medium', value: 4 }, { name: 'Low', value: 43 }],
    },
    stachbar: {
        name: "Cumulative Systems at Risk (Weekly)",
        value: [
            { name: "High", data: [2,3,3,4,4,3,3,3,3,4,3] },
            { name: "Medium", data: [4,3,3,4,2,2,2,3,4,4,2] },
            { name: "Low", data: [44,44,44,42,44,45,45,44,43,42,45] },
        ]
    },
    SystemsHighRisk: {
        data: ["WT-32", "WT-07", "WT-3", "WT-11", "WT-18", "WT-43", "WT-05", "WT-01", "WT-19", "WT-21"],
        value: [2, 3, 5, 8, 10, 11, 13, 14, 16, 17]
    }
    },
    {},
    {},
    {
        GenerationStats: {
            name: "Daily Generation Stats",
            headerNames: {
                headeName1: "Total (MWh)",
                headeName2: "Revenue (Million)",
                headeName3: "Load Factor",
                headeName4: "Fuel Costs (Million)",
            },
            headerValues: {
                headerValue1: 10204,
                headerValue2: "$10.5",
                headerValue3: '80%',
                headerValue4: "$6.50",
            },
            data: [7, 8, 7.5, 9, 8.5, 10.5]
        },
        Availability: {
            formatter: "%",
            seriesname: 'Availability',
            name: "Average Availability",
            subName: " (84%)",
            percentage: "1%",
            arrow: "arrow_upward",
            data: [86, 83, 83, 83, 84]
        },
        HeatRate: {
            formatter: "KCal/KWh",
            seriesname: 'Heat Rate',
            name: "Average Heat Rate",
            subName: " (2011 KCal/KWh)",
            percentage: "0.1%",
            arrow: "arrow_downward",
            data: [2050, 2030, 2040, 2020, 2011]
        },
        DMWaterConsumption: {
            formatter: "KGallons",
            seriesname: 'DM Water Consumption',
            name: "Average DM Water ",
            subName: " (101 KGallons)",
            percentage: "0.2%",
            arrow: "arrow_upward",
            data: [101, 102, 103, 101, 101]
        },
        AuxPowerConsumption: {
            formatter: "%",
            seriesname: 'Aux Power Consumption',
            name: "Average Aux Power",
            subName: " (7% of Generation)",
            percentage: "0.5%",
            arrow: "arrow_downward",
            data: [9, 7, 7.5, 6, 7]
        },
        tableData: {
            name: "Unit Overview",
            data: [
                { UnitName: "Unit 1", Generation: 120, PlantLoadFactor: 60, ContinuousRun: "110 days", CurrentYearAvailability: 55, SystemsatRisk: "2/15" },
                { UnitName: "Unit 2", Generation: 120, PlantLoadFactor: 98, ContinuousRun: "95 days", CurrentYearAvailability: 93, SystemsatRisk: "0/15" },
                { UnitName: "Unit 3", Generation: 120, PlantLoadFactor: 100, ContinuousRun: "99 days", CurrentYearAvailability: 85, SystemsatRisk: "2/15" },
                { UnitName: "Unit 4", Generation: 120, PlantLoadFactor: 100, ContinuousRun: "105 days", CurrentYearAvailability: 90, SystemsatRisk: "1/15" },
                { UnitName: "Unit 5", Generation: 120, PlantLoadFactor: 101, ContinuousRun: "119 days", CurrentYearAvailability: 95, SystemsatRisk: "1/16" },

            ]
        },
        SystemsRisk: {
            name: "Systems at High Risk",
            data: [{ name: 'High', value: 6 }, { name: 'Medium', value: 19 }, { name: 'Low', value: 65 }],
        },
        stachbar: {
            name: "Cumulative Systems at Risk (Weekly)",
            value: [
                { name: "Unit 1", data: [1, 2, 3, 3, 4, 4, 3, 4, 4, 5, 6] },
                { name: "Unit 2", data: [2, 3, 3, 4, 4, 3, 3, 3, 3, 4, 4] },
                { name: "Unit 3", data: [4, 3, 3, 4, 2, 2, 2, 3, 4, 4, 3] },
                { name: "Unit 4", data: [2, 1, 1, 2, 3, 2, 1, 1, 2, 2, 2] },
                { name: "Unit 5", data: [1, 1, 0, 1, 1, 0, 0, 1, 1, 0, 0] },
            ]
        },
        SystemsHighRisk: {
            data: ["Unit 1 - Condenser", "Unit 1 - ID Fan", "Unit 1 - Coal Mill", "Unit 1 - FD Fan", "Unit 1 - Boiler Feed Pump B", "Unit 1 - Boiler Feed Pump A", "Unit 1 - Boiler", "Unit 1 - Turbine", "Unit 1 - Turbine", "Unit 1 - Generator"],
            value: [2, 3, 5, 8, 10, 11, 13, 14, 16, 17]
        }
    }
]


